import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WarningItem, WarningList } from 'components/node_settings/V4Settings/styled';

type SettingWarningsProps = Readonly<{
    messages: readonly string[];
    testId?: string;
}>;

export function SettingWarnings({ messages, testId }: SettingWarningsProps) {
    return (
        <WarningList data-testid={testId}>
            {messages.map((message) => (
                <WarningItem key={message}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    {message}
                </WarningItem>
            ))}
        </WarningList>
    );
}
